
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#5F6368","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11.995 2.197c-5.402 0-9.798 4.396-9.798 9.798 0 5.403 4.396 9.798 9.798 9.798 5.403 0 9.799-4.395 9.799-9.798 0-5.402-4.396-9.798-9.799-9.798m0 21.793C5.381 23.99 0 18.61 0 11.995 0 5.381 5.38 0 11.995 0 18.61 0 23.991 5.38 23.991 11.995c0 6.614-5.381 11.995-11.996 11.995"}}),_c('path',{attrs:{"d":"M16.912 9.752a3.623 3.623 0 0 1-1.041.285c.374-.224.661-.58.797-1.003-.35.208-.738.359-1.151.44a1.813 1.813 0 0 0-3.09 1.654A5.148 5.148 0 0 1 8.69 9.233a1.813 1.813 0 0 0 .56 2.421 1.805 1.805 0 0 1-.82-.227v.023c0 .878.625 1.61 1.454 1.777a1.8 1.8 0 0 1-.819.032c.231.72.9 1.244 1.695 1.259a3.636 3.636 0 0 1-2.685.75 5.13 5.13 0 0 0 2.779.815c3.335 0 5.159-2.763 5.159-5.158a5.4 5.4 0 0 0-.006-.235c.355-.255.662-.575.905-.938"}})])])
          )
        }
      }
    